import Vue from 'vue';
import VueGtag from 'vue-gtag';
import VueYandexMetrika from 'vue-yandex-metrika';

import ModalWindow from '@/components/Form/ModalWindow/index.vue';

import Api from '@/service/api';
import Auth from '@/service/auth';
import LocalCookieStorage from '@/service/localCookieStorage';
import { ALLOWED_COOKIE_NITICE_TYPES, ONE_YEAR } from '@/constants/constants';


export default {
  name: 'CookieNotice',

  components: {
    ModalWindow,
  },

  watch: {
    '$route.name': {
      handler(data) {
        const allowState = this.$store.getters.cookieAllowState;

        if (this.$refs.cookieModal) {
          if (!allowState) {
            if (data === 'CookiePolicy') {
              this.$refs.cookieModal.close();
              return;
            }
            this.$refs.cookieModal.show();
          } if (allowState === 'all') {
            this.loadMetrics();
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async getLogin() {
      let response = null;
      const sessionId = Auth.getSession();

      if (!sessionId) {
        return '';
      }

      try {
        response = await Api.post({
          url: 'oauth2/get-user',
          data: {
            session_id: sessionId.replace(/"/g, ''),
          },
          preloader: false,
        });
      } catch (error) {
        return '';
      }

      return response.email || response.phone || '';
    },

    acceptAll() {
      LocalCookieStorage.set('cookie-allow', 'all', ONE_YEAR);
      this.$store.commit('changeCookieAllowState', 'all');
      this.$refs.cookieModal.close();
      this.loadMetrics();
    },

    acceptNecessary() {
      LocalCookieStorage.set('cookie-allow', 'necessary', ONE_YEAR);
      this.$store.commit('changeCookieAllowState', 'necessary');
      this.$refs.cookieModal.close();
    },

    moreInfo() {
      this.$refs.cookieModal.close();
    },

    loadMetrics() {
      const login = this.getLogin();
      if (!login) {
        return;
      }

      Vue.use(VueYandexMetrika, {
        id: 38454160,
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
        trackHash: true,
        router: this.$router,
        env: process.env.NODE_ENV,
        userParams: { login },
      });

      Vue.use(VueGtag, {
        config: {
          id: 'UA-40384099-7',
          params: {
            send_page_view: true,
          },
        },
      });
    },
  },

  mounted() {
    if (this.$route.name === 'CookiePolicy') {
      return;
    }

    this.allowState = LocalCookieStorage.get('cookie-allow');
    this.$store.commit('changeCookieAllowState', this.allowState);

    if (this.allowState === 'all') {
      this.loadMetrics();
    }

    if (!ALLOWED_COOKIE_NITICE_TYPES.includes(this.allowState)) {
      this.$refs.cookieModal.show();
    }
  },

  data() {
    return {
      isShowModal: false,
    };
  },
};
